// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ca89NG9D6ENr9iKbC8xL {
  position: absolute;
  top: 80px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 1000;
}

.ca89NG9D6ENr9iKbC8xL:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: scale(1.05);
}

.ca89NG9D6ENr9iKbC8xL:active {
  transform: scale(0.95);
}`, "",{"version":3,"sources":["webpack://./src/editor/components/viewport/ARControls/VisibilityToggle.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wCAAA;EACA,aAAA;AACF;;AAEA;EACE,8BAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visibilityToggleButton": `ca89NG9D6ENr9iKbC8xL`
};
export default ___CSS_LOADER_EXPORT___;
